import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IReEnrollmentCyclesResponse,
  IReEnrollmentCycleResponseById,
  IReEnrollmentCyclesQueryParams,
  IActivateReEnrollmentCycleResponse,
  IFinalizeReEnrollmentCycleResponse,
} from '../../interface/reEnrollment.interface';
import { IErrorResponse } from '../../interface/main.interface';
import { reEnrollmentService } from '../../services/reEnrollment';
import { normalizeAxiosError } from '../../utility/axiosErrorHandler';

// Fetch all re-enrollment cycles with optional query params
export const fetchReEnrollmentCycles = createAsyncThunk<
  IReEnrollmentCyclesResponse,
  IReEnrollmentCyclesQueryParams | undefined,
  { rejectValue: IErrorResponse }
>('reEnrollment/fetch-all', async (params, { rejectWithValue }) => {
  try {
    const response = await reEnrollmentService.fetchReEnrollmentCycles(params);
    return response.data;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to fetch re-enrollment cycles.'));
  }
});

// Fetch single re-enrollment cycle by ID
export const fetchReEnrollmentCycle = createAsyncThunk<
  IReEnrollmentCycleResponseById,
  string,
  { rejectValue: IErrorResponse }
>('reEnrollment/fetch-one', async (cycleId, { rejectWithValue }) => {
  try {
    const response = await reEnrollmentService.fetchReEnrollmentCycle(cycleId);
    return response.data;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to fetch re-enrollment cycle.'));
  }
});

// Activate re-enrollment cycle
export const activateReEnrollmentCycle = createAsyncThunk<
  IActivateReEnrollmentCycleResponse,
  string,
  { rejectValue: IErrorResponse }
>('reEnrollment/activate-cycle', async (cycleId, { rejectWithValue }) => {
  try {
    const response = await reEnrollmentService.activateReEnrollmentCycle(cycleId);
    return response.data;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to activate re-enrollment cycle.'));
  }
});

// Finalize re-enrollment cycle
export const finalizeReEnrollmentCycle = createAsyncThunk<
  IFinalizeReEnrollmentCycleResponse,
  string,
  { rejectValue: IErrorResponse }
>('reEnrollment/finalize-cycle', async (cycleId, { rejectWithValue }) => {
  try {
    const response = await reEnrollmentService.finalizeReEnrollmentCycle(cycleId);
    return response.data;
  } catch (err) {
    return rejectWithValue(normalizeAxiosError(err, 'Failed to finalize re-enrollment cycle.'));
  }
});

export const reEnrollmentActions = {
  fetchReEnrollmentCycles,
  fetchReEnrollmentCycle,
  activateReEnrollmentCycle,
  finalizeReEnrollmentCycle,
};
